import React, { memo, useContext } from "react";
import { makeStyles } from "@mui/styles";
import { Box, Dialog, IconButton, TableCell, TableRow } from "@mui/material";

import { useState } from "react";
import ConfirmacionDialog from "../../../../components/Extra/ConfirmacionDialog";
import { withRouter } from "react-router";
import ButtonsAction from "./ButtonsAction";
import AuthContext from "../../../../Context/Auth/AuthContext";
import { Download, Visibility } from "@mui/icons-material";
import CollapseCell from "../../../../components/Extra/CollapseCell";
import ModalEmail from "../../../../components/Extra/ModalEmail";
import CallNombrePersona from "../../../components/Tablas/CallNombrePersona";
const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  hover: {
    "&:hover": {
      opacity: ".7",
      cursor: "pointer",
    },
  },
  celda: {
    fontSize: ".7rem !important",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));

const Row = (props) => {
  const {
    arrayExport,
    setarrayExport,
    row,
    index,
    campoExport,
    puedeExportar,
    desdeOtroLugar,
    seteditar,
    setopen,
    changeObjetoActivoState,
    socket,
    tienePermiso,
    alertaPermiso,
    eliminadoEstado,
  } = props;
  const { usuario } = useContext(AuthContext);
  const classes = useRowStyles();

  const handleEliminar = async (_id) => {
    if (!tienePermiso("eliminar")) {
      return alertaPermiso("eliminar");
    }
    try {
      socket.current.emit("client:eliminarData", {
        nombre: usuario.nombre,
        tabla: "examen",
        rucempresa: usuario.rucempresa,
        rol: usuario.rol,
        exaUser: usuario.usuario,
        exaEmpresa: usuario.rucempresa,
        exaId: row.exaId,
      });
    } catch (error) {}
  };
  const funcionEdit = () => {
    setopen(true);
    seteditar(true);
    changeObjetoActivoState({ ...row, restaurado: eliminadoEstado });
  };
  const [celComprimida, setcelComprimida] = useState({});
  const [Openimagen, setOpenimagen] = useState(false);
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  const [openModalEmail, setopenModalEmail] = useState(false);
  return (
    <React.Fragment>
      <Dialog
        open={Openimagen}
        onClose={() => setOpenimagen(false)}
        aria-labelledby="draggable-dialog-title"
      >
        {row.exaFoto === "" || !Openimagen ? null : (
          <img src={row.exaFoto} alt="Imagen" />
        )}
      </Dialog>
      <ConfirmacionDialog
        open={openConfirmDialog}
        setopen={setopenConfirmDialog}
        titulo={`¿Esta seguro de eliminar este registro?`}
        _id={row._id}
        funcion={handleEliminar}
      />{" "}
      <ModalEmail
        open={openModalEmail}
        setopen={setopenModalEmail}
        id={row.exaId}
        documento={"Examen"}
        // emailDefecto={row.resPerEmail}
        campos={[
          {
            label: "Documento",
            propiedad: "Examen",
          },
          {
            label: "Nombre",
            propiedad: row.exaPerNombre,
          },
        ]}
      />
      <TableRow className={classes.root} selected={index % 2 === 0}>
        {/* boton */}
        <ButtonsAction
          eliminadoEstado={eliminadoEstado}
          arrayExport={arrayExport}
          setarrayExport={setarrayExport}
          row={row}
          setopenConfirmDialog={setopenConfirmDialog}
          funcionEdit={funcionEdit}
          ocultarEditar={false}
          ocultarDelete={false}
          mostrarEstado={false}
          campoExport={campoExport}
          campoEstado=""
          puedeExportar={puedeExportar}
          desdeOtroLugar={desdeOtroLugar}
          setopenModalEmail={setopenModalEmail}
        />
        <>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.exaTipo}
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.exaMascNombre}
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.exaPerNombre}
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.exaFoto === "" ? (
              "No hay imagen"
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                padding="none"
                alignItems="center"
              >
                <IconButton
                  aria-label=""
                  size="small"
                  onClick={() => setOpenimagen(true)}
                  className={classes.margin}
                >
                  <Visibility size="small" color="secondary" />
                </IconButton>
              </Box>
            )}
          </TableCell>
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {row.exaArchivo === "" ? (
              "No hay documento"
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                padding="none"
                alignItems="center"
              >
                <IconButton
                  className={classes.margin}
                  onClick={() => {
                    window.open(row.exaArchivo);
                  }}
                >
                  <Download fontSize="small" color="primary" />
                </IconButton>
              </Box>
            )}
          </TableCell>
          <CollapseCell
            celComprimida={celComprimida}
            setcelComprimida={setcelComprimida}
            row={row}
            propiedad={"exaDescripcion"}
          />
          <CallNombrePersona user={row.exaUser} />
          <TableCell
            padding="none"
            size="small"
            align="center"
            className={classes.celda}
          >
            {new Date(row.exaFecUpd).toLocaleString("es-ES", {
              weekday: "short",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour: "2-digit",
            })}
          </TableCell>
        </>
      </TableRow>
    </React.Fragment>
  );
};

export default withRouter(memo(Row));
